import { useEffect } from 'react';
import { isNotificationsEnabled } from '@/config/env';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { watchService } from '../services/watchService';

/**
 * Tells Notifications about the signed-in user's current address once per session.
 *
 * Notifications stores the address and its verified flag from the token when someone follows
 * something. Without this, verifying or changing an address afterwards would not reach it
 * until their next follow, and the daily email would not arrive or would go to the old one.
 *
 * Best effort and silent: a failure here costs only that refresh, and must not interrupt
 * whatever the user came to do.
 */
export function SubscriberSync(): null {
  const { user } = useAuth();
  const userId = user?.id ?? null;

  useEffect(() => {
    if (!isNotificationsEnabled || userId === null) return;
    watchService.refreshSubscriber().catch(() => undefined);
  }, [userId]);

  return null;
}
